/**
 * How much of a recipe's blurb the header shows before « Lire la suite » (#743).
 *
 * A phone keeps the blurb to three lines: it sits between the title and the
 * first ingredient on a narrow screen. A tablet or desktop has the room, and an
 * iPad user reported a three-line cut beside half a screen of empty space, so
 * the wide layout shows it open. Eight lines is a backstop for the rare imported
 * essay, not a cut most blurbs reach (~100 characters a line at 820 px).
 *
 * The toggle is offered only when the text was actually cut — it used to show
 * under every blurb, even one that fit.
 */

export interface DescriptionClamp {
  maxLines: number;
  lineHeight: number;
}

export const NARROW_DESCRIPTION: DescriptionClamp = { maxLines: 3, lineHeight: 22 };
export const WIDE_DESCRIPTION: DescriptionClamp = { maxLines: 8, lineHeight: 24 };

export const descriptionClamp = (isWideLayout: boolean): DescriptionClamp =>
  isWideLayout ? WIDE_DESCRIPTION : NARROW_DESCRIPTION;

/**
 * True when the unclamped text is taller than the clamp allows.
 *
 * `fullHeight` is the measured height of the same text with no line limit; 0
 * means it has not been measured yet, which reads as "fits" so the toggle never
 * flashes in on first paint. A pixel of slack absorbs sub-pixel layout.
 */
export const isDescriptionCut = (fullHeight: number, clamp: DescriptionClamp): boolean =>
  fullHeight > clamp.maxLines * clamp.lineHeight + 1;
